import styled from 'styled-components';
import { colors } from '../colors';
import Loader from '../../assets/Infinity_loader.svg';
import { FC, ComponentPropsWithoutRef } from 'react';
interface IButton extends ComponentPropsWithoutRef<'button'> {
  buttonText: string;
  isLoading: boolean;
  width?: string;
}

export const BasicButton = styled.button`
  background-color: ${colors.sojiOrange};
  color: ${colors.white};
  cursor: pointer;
  transition: 0.3s ease-in-out;
  border: none;
  padding: 11px 45px;
  border-radius: 8px;

  &:hover {
    opacity: 0.6;
  }
`;
export const LoadingButton = () => {
  return <ButtonLoader src={Loader} />;
};

export const LoaderButton: FC<IButton> = ({
  buttonText,
  isLoading,
  className,
  ...rest
}) => {
  return (
    <ButtonContainer {...rest} className={className}>
      {isLoading ? <ButtonLoader src={Loader} /> : buttonText}
    </ButtonContainer>
  );
};
const ButtonContainer = styled(BasicButton)``;
const ButtonLoader = styled.img`
  width: 35px;
  height: 12px;
  object-fit: cover;
`;
